import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import selfCareUploadFileSliceReducer from './selfCareUploadFileSlice';

export default class SelfCareUploadFileModule implements IInitializableModule {
  protected name: string = 'self care upload file  form module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
  }

  public StartModule(context: IEpiserverContext): void {
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'SelfCareUploadFile',
      reducer: selfCareUploadFileSliceReducer,
    };
  }
}
